import { render, staticRenderFns } from "./PeptideCalculator.vue?vue&type=template&id=0e6c6478&scoped=true"
import script from "./PeptideCalculator.vue?vue&type=script&lang=js"
export * from "./PeptideCalculator.vue?vue&type=script&lang=js"
import style0 from "./PeptideCalculator.vue?vue&type=style&index=0&id=0e6c6478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6c6478",
  null
  
)

export default component.exports